(function () {
  const modalBtns = document.querySelectorAll('.modal__button-team-modal');
  const modals = document.querySelectorAll('.modal__wrapper');

  if (!modalBtns.length || !modals.length) return;

  modalBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const modal = btn.parentNode.nextElementSibling;
      const closeBtn = modal.querySelector('.button-close');
      const focusableEls = modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstFocusableEl = focusableEls[0];
      const lastFocusableEl = focusableEls[focusableEls.length - 1];

      modal.classList.toggle('active');
      modal.style.display = 'block';
      modal.toggleAttribute('aria-hidden');
      modal.toggleAttribute('aria-modal');
      btn.toggleAttribute('aria-expanded');

      closeBtn.addEventListener('click', () => {
        modal.classList.remove('active');
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('aria-modal', 'false');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      });

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          modal.classList.remove('active');
          modal.style.display = 'none';
          modal.toggleAttribute('aria-hidden');
          modal.toggleAttribute('aria-modal');
          btn.toggleAttribute('aria-expanded');
          btn.focus();
        }

        if (event.key === 'Tab') {
          if (event.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
              event.preventDefault();
              lastFocusableEl.focus();
            }
          } else {
            if (document.activeElement === lastFocusableEl) {
              event.preventDefault();
              firstFocusableEl.focus();
            }
          }
        }
      });

      setTimeout(() => {
        firstFocusableEl.focus();
      }, 100);
    });
  });
})();
